<div *ngFor="let tableSection of tableSections" class="">
  <div class="body-table" [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
</div>
